import {createRenderLinkRow} from '@/utils/createRenderLinkRow';
import {getMunicipalityByCode,renderProvince} from '@/utils/location';

import {renderActions} from '../containers/HistorianOfficesRowActions';
import {ROUTE_PATH_HISTORIAN_OFFICES} from './historianOffices';

export const columns = [
  {
    key: 'name',
    title: 'historianOffices.name.label',
    dataIndex: 'name',
    render: createRenderLinkRow({
      path: ROUTE_PATH_HISTORIAN_OFFICES,
      subKeysToShow: [
        'email',
        'phone',
        'province',
        'municipality',
      ],
    }),
  },
  {
    key: 'email',
    title: 'historianOffices.email.label',
    dataIndex: 'email',
    type: 'email',
    responsive: ['lg'],
  },
  {
    key: 'phone',
    title: 'historianOffices.phone.label',
    align: 'phone',
    dataIndex: 'phone',
    responsive: ['lg'],
  },{
    key: 'province',
    title: 'province',
    dataIndex: ['address', 'province'],
    responsive: ['lg'],
    width: 150,
    render: renderProvince
  },
  {
    key: 'municipality',
    title: 'municipality',
    dataIndex: ['address','municipality'],
    responsive: ['lg'],
    render: (v) => getMunicipalityByCode(v)?.name
  },
  {
    key: 'actions',
    title: 'actions',
    dataIndex: 'actions',
    align: 'center',
    width: 100,
    render: renderActions
  }
];
